import { ZincReader } from '@j2inn/haystack-core'

const formatZincToJson = (data: any) => {
    return JSON.parse(JSON.stringify(new ZincReader(data).readValue()))
}

export { formatZincToJson }
